<span class="header-name" (click)="sort()">{{params.name}}
    <i *ngIf="params.enableSorting" [class]="sortIcon"></i>
    <i [class]="params.icon"></i>
</span>